import boboPic from "@/public/images/artists/bobo.png";
import { Artist } from "@/types/types";

export const bobo = {
  id: "135",
  name: "Bobo",
  image: boboPic,
  description: `Bobo's voice is characterized by a bright, clear tone that enhances its natural expressiveness and emotional depth. Bobo's smooth delivery is enriched by a subtle, natural vibrato, adding a lively and organic feel to the resonant and textured timbre.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fbobo-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Afrobeat", "Dance", "Pop", "Unprocessed", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 48,
        high: 72,
      },
      sweetSpot: 53,
    },
  },
} as const satisfies Artist;
